export const customerShouldUseCabelasPaymentForm = (productTier: string) => {
	const expectedSubstringForCabelasPurchase = 'cabela';
	return productTier.toLowerCase().includes(expectedSubstringForCabelasPurchase);
};
